import React, { useState, useRef } from 'react'
import { IbanElement, useStripe, useElements } from '@stripe/react-stripe-js'
import { useFormik } from 'formik'
import { createSEPAPayment } from '../../../apis/paymentAPI'
import { ibanStripeValidationSchema } from '../../../Validations/ibanStripeValidation'

const IBanStripe = ({ userName, userEmail, slug, setSuccess }) => {
  const stripe = useStripe()
  const elements = useElements()
  const [errorMessage, setErrorMessage] = useState('')
  const [loading, setLoading] = useState(false)
  const [ibanInitialValues, setIbanInitialValues] = useState({
    name: userName || '',
    email: userEmail || ''
  })
  const ibanRef = useRef(null)

  const formik = useFormik({
    initialValues: ibanInitialValues,
    validationSchema: ibanStripeValidationSchema,
    onSubmit: async values => {
      setLoading(true)
      setSuccess('Success')

      if (!stripe || !elements) {
        setErrorMessage('Stripe is not properly initialized')
        setLoading(false)
        return
      }

      try {
        const resp = await stripe.createPaymentMethod({
          type: 'sepa_debit',
          sepa_debit: elements.getElement(IbanElement),
          billing_details: {
            name: values.name,
            email: values.email
          }
        })

        if (resp.error) {
          setErrorMessage(resp.error.message)
          setLoading(false)
          return
        }

        const response = await createSEPAPayment({
          payment_method_id: resp.paymentMethod.id,
          amount: 1099
        })

        const paymentIntentResponse = await response.json()
        if (paymentIntentResponse.error) {
          setErrorMessage(paymentIntentResponse.error)
        } else {
          console.log(paymentIntentResponse.paymentIntent)
        }
      } catch (error) {
        setErrorMessage('Error processing payment')
        console.error(error)
      } finally {
        setLoading(false)
      }
    }
  })

  return (
    <>
      {/* <hr /> */}
      <h5>IBAN / SEPA Payment</h5>
      <div>
        <form onSubmit={formik.handleSubmit} className='row g-3'>
          <div class='col-md-6'>
            <label htmlFor='name'>Name*:</label>
            <input
              id='name'
              name='name'
              type='text'
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.name}
              className='form-control'
            />
            {formik.touched.name && formik.errors.name ? (
              <div className='text-danger'>{formik.errors.name}</div>
            ) : null}
          </div>

          <div class='col-md-6'>
            <label htmlFor='email'>Email*:</label>
            <input
              id='email'
              name='email'
              type='email'
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
              className='form-control'
            />
            {formik.touched.email && formik.errors.email ? (
              <div className='text-danger'>{formik.errors.email}</div>
            ) : null}
          </div>

          <div class='col-md-12'>
            <label htmlFor='iban'>IBAN No*:</label>
            <IbanElement
              ref={ibanRef}
              options={{ supportedCountries: ['SEPA'] }}
              onChange={e => {
                console.log(e)
              }}
              className='form-control'
            />
          </div>
          <div class='col-md-12'>
            <button
              type='submit'
              disabled={!stripe || loading}
              className='btn btn-primary mb-3'
              style={{ width: 'auto' }}
            >
              {loading ? 'Submitting...' : 'Submit Payment'}
            </button>
            {errorMessage && <div>{errorMessage}</div>}
          </div>
        </form>
      </div>
    </>
  )
}

export default IBanStripe
